import type { Component } from "vue";

export interface TicketViewRegistration {
  twinTypePattern: string;
  component: Component;
}

const registry: TicketViewRegistration[] = [];

function patternToRegex(pattern: string): RegExp {
  const escaped = pattern
    .replace(/[.+^${}()|[\]\\]/g, "\\$&")
    .replace(/\*/g, ".*");
  return new RegExp(`^${escaped}$`);
}

export function registerTicketView(registration: TicketViewRegistration): void {
  if (
    registry.some(
      (entry) => entry.twinTypePattern === registration.twinTypePattern,
    )
  ) {
    return;
  }
  registry.push(registration);
}

export function getTicketView(
  twinType: string | undefined,
): Component | undefined {
  if (!twinType) return undefined;
  return registry.find((entry) =>
    patternToRegex(entry.twinTypePattern).test(twinType),
  )?.component;
}